/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createWorld = /* GraphQL */ `
  mutation CreateWorld(
    $input: CreateWorldInput!
    $condition: ModelWorldConditionInput
  ) {
    createWorld(input: $input, condition: $condition) {
      id
      title
      createdAt
      updatedAt
      quests {
        items {
          id
          title
          worldId
          type
          kilometers
          checkpointCount
          starsToUnlock
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const updateWorld = /* GraphQL */ `
  mutation UpdateWorld(
    $input: UpdateWorldInput!
    $condition: ModelWorldConditionInput
  ) {
    updateWorld(input: $input, condition: $condition) {
      id
      title
      createdAt
      updatedAt
      quests {
        items {
          id
          title
          worldId
          type
          kilometers
          checkpointCount
          starsToUnlock
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const deleteWorld = /* GraphQL */ `
  mutation DeleteWorld(
    $input: DeleteWorldInput!
    $condition: ModelWorldConditionInput
  ) {
    deleteWorld(input: $input, condition: $condition) {
      id
      title
      createdAt
      updatedAt
      quests {
        items {
          id
          title
          worldId
          type
          kilometers
          checkpointCount
          starsToUnlock
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const createQuest = /* GraphQL */ `
  mutation CreateQuest(
    $input: CreateQuestInput!
    $condition: ModelQuestConditionInput
  ) {
    createQuest(input: $input, condition: $condition) {
      id
      title
      worldId
      type
      kilometers
      checkpointCount
      starsToUnlock
      createdAt
      updatedAt
    }
  }
`;
export const updateQuest = /* GraphQL */ `
  mutation UpdateQuest(
    $input: UpdateQuestInput!
    $condition: ModelQuestConditionInput
  ) {
    updateQuest(input: $input, condition: $condition) {
      id
      title
      worldId
      type
      kilometers
      checkpointCount
      starsToUnlock
      createdAt
      updatedAt
    }
  }
`;
export const deleteQuest = /* GraphQL */ `
  mutation DeleteQuest(
    $input: DeleteQuestInput!
    $condition: ModelQuestConditionInput
  ) {
    deleteQuest(input: $input, condition: $condition) {
      id
      title
      worldId
      type
      kilometers
      checkpointCount
      starsToUnlock
      createdAt
      updatedAt
    }
  }
`;
export const createPlayer = /* GraphQL */ `
  mutation CreatePlayer(
    $input: CreatePlayerInput!
    $condition: ModelPlayerConditionInput
  ) {
    createPlayer(input: $input, condition: $condition) {
      id
      purpose
      name
      starTotal
      effortTotal
      rideDurTotal
      wattHrsTotal
      coinTotal
      createdAt
      updatedAt
      restricted {
        id
        stravaAccessToken
        stravaRefreshToken
        stravaTokenExpiresAt
        stravaScope
        createdAt
        updatedAt
      }
    }
  }
`;
export const updatePlayer = /* GraphQL */ `
  mutation UpdatePlayer(
    $input: UpdatePlayerInput!
    $condition: ModelPlayerConditionInput
  ) {
    updatePlayer(input: $input, condition: $condition) {
      id
      purpose
      name
      starTotal
      effortTotal
      rideDurTotal
      wattHrsTotal
      coinTotal
      createdAt
      updatedAt
      restricted {
        id
        stravaAccessToken
        stravaRefreshToken
        stravaTokenExpiresAt
        stravaScope
        createdAt
        updatedAt
      }
    }
  }
`;
export const deletePlayer = /* GraphQL */ `
  mutation DeletePlayer(
    $input: DeletePlayerInput!
    $condition: ModelPlayerConditionInput
  ) {
    deletePlayer(input: $input, condition: $condition) {
      id
      purpose
      name
      starTotal
      effortTotal
      rideDurTotal
      wattHrsTotal
      coinTotal
      createdAt
      updatedAt
      restricted {
        id
        stravaAccessToken
        stravaRefreshToken
        stravaTokenExpiresAt
        stravaScope
        createdAt
        updatedAt
      }
    }
  }
`;
export const createPlayerRestricted = /* GraphQL */ `
  mutation CreatePlayerRestricted(
    $input: CreatePlayerRestrictedInput!
    $condition: ModelPlayerRestrictedConditionInput
  ) {
    createPlayerRestricted(input: $input, condition: $condition) {
      id
      stravaAccessToken
      stravaRefreshToken
      stravaTokenExpiresAt
      stravaScope
      createdAt
      updatedAt
    }
  }
`;
export const updatePlayerRestricted = /* GraphQL */ `
  mutation UpdatePlayerRestricted(
    $input: UpdatePlayerRestrictedInput!
    $condition: ModelPlayerRestrictedConditionInput
  ) {
    updatePlayerRestricted(input: $input, condition: $condition) {
      id
      stravaAccessToken
      stravaRefreshToken
      stravaTokenExpiresAt
      stravaScope
      createdAt
      updatedAt
    }
  }
`;
export const deletePlayerRestricted = /* GraphQL */ `
  mutation DeletePlayerRestricted(
    $input: DeletePlayerRestrictedInput!
    $condition: ModelPlayerRestrictedConditionInput
  ) {
    deletePlayerRestricted(input: $input, condition: $condition) {
      id
      stravaAccessToken
      stravaRefreshToken
      stravaTokenExpiresAt
      stravaScope
      createdAt
      updatedAt
    }
  }
`;
export const createActivityPeriod = /* GraphQL */ `
  mutation CreateActivityPeriod(
    $input: CreateActivityPeriodInput!
    $condition: ModelActivityPeriodConditionInput
  ) {
    createActivityPeriod(input: $input, condition: $condition) {
      id
      createdAt
      owner
      startDate
      effortCount
      starCount
      wattHrs
      coinCount
      rideDuration
      effortTotal
      starTotal
      wattHrsTotal
      coinTotal
      rideDurTotal
      updatedAt
      rides {
        items {
          id
          createdAt
          title
          duration
          kilometers
          wattHours
          coinGain
          starGain
          completed
          owner
          worldId
          updatedAt
        }
        nextToken
      }
      questEfforts {
        items {
          id
          createdAt
          score
          metric
          starRating
          starGain
          completed
          isRankChecked
          owner
          questId
          rideId
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const updateActivityPeriod = /* GraphQL */ `
  mutation UpdateActivityPeriod(
    $input: UpdateActivityPeriodInput!
    $condition: ModelActivityPeriodConditionInput
  ) {
    updateActivityPeriod(input: $input, condition: $condition) {
      id
      createdAt
      owner
      startDate
      effortCount
      starCount
      wattHrs
      coinCount
      rideDuration
      effortTotal
      starTotal
      wattHrsTotal
      coinTotal
      rideDurTotal
      updatedAt
      rides {
        items {
          id
          createdAt
          title
          duration
          kilometers
          wattHours
          coinGain
          starGain
          completed
          owner
          worldId
          updatedAt
        }
        nextToken
      }
      questEfforts {
        items {
          id
          createdAt
          score
          metric
          starRating
          starGain
          completed
          isRankChecked
          owner
          questId
          rideId
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const deleteActivityPeriod = /* GraphQL */ `
  mutation DeleteActivityPeriod(
    $input: DeleteActivityPeriodInput!
    $condition: ModelActivityPeriodConditionInput
  ) {
    deleteActivityPeriod(input: $input, condition: $condition) {
      id
      createdAt
      owner
      startDate
      effortCount
      starCount
      wattHrs
      coinCount
      rideDuration
      effortTotal
      starTotal
      wattHrsTotal
      coinTotal
      rideDurTotal
      updatedAt
      rides {
        items {
          id
          createdAt
          title
          duration
          kilometers
          wattHours
          coinGain
          starGain
          completed
          owner
          worldId
          updatedAt
        }
        nextToken
      }
      questEfforts {
        items {
          id
          createdAt
          score
          metric
          starRating
          starGain
          completed
          isRankChecked
          owner
          questId
          rideId
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const createRide = /* GraphQL */ `
  mutation CreateRide(
    $input: CreateRideInput!
    $condition: ModelRideConditionInput
  ) {
    createRide(input: $input, condition: $condition) {
      id
      createdAt
      title
      duration
      kilometers
      wattHours
      coinGain
      starGain
      completed
      owner
      worldId
      updatedAt
      player {
        id
        purpose
        name
        starTotal
        effortTotal
        rideDurTotal
        wattHrsTotal
        coinTotal
        createdAt
        updatedAt
        restricted {
          id
          stravaAccessToken
          stravaRefreshToken
          stravaTokenExpiresAt
          stravaScope
          createdAt
          updatedAt
        }
      }
      activityPeriod {
        id
        createdAt
        owner
        startDate
        effortCount
        starCount
        wattHrs
        coinCount
        rideDuration
        effortTotal
        starTotal
        wattHrsTotal
        coinTotal
        rideDurTotal
        updatedAt
        rides {
          nextToken
        }
        questEfforts {
          nextToken
        }
      }
      questEfforts {
        items {
          id
          createdAt
          score
          metric
          starRating
          starGain
          completed
          isRankChecked
          owner
          questId
          rideId
          updatedAt
        }
        nextToken
      }
      questRanks {
        items {
          createdAt
          score
          starRating
          owner
          questId
          rideId
          effortId
          updatedAt
        }
        nextToken
      }
      world {
        id
        title
        createdAt
        updatedAt
        quests {
          nextToken
        }
      }
    }
  }
`;
export const updateRide = /* GraphQL */ `
  mutation UpdateRide(
    $input: UpdateRideInput!
    $condition: ModelRideConditionInput
  ) {
    updateRide(input: $input, condition: $condition) {
      id
      createdAt
      title
      duration
      kilometers
      wattHours
      coinGain
      starGain
      completed
      owner
      worldId
      updatedAt
      player {
        id
        purpose
        name
        starTotal
        effortTotal
        rideDurTotal
        wattHrsTotal
        coinTotal
        createdAt
        updatedAt
        restricted {
          id
          stravaAccessToken
          stravaRefreshToken
          stravaTokenExpiresAt
          stravaScope
          createdAt
          updatedAt
        }
      }
      activityPeriod {
        id
        createdAt
        owner
        startDate
        effortCount
        starCount
        wattHrs
        coinCount
        rideDuration
        effortTotal
        starTotal
        wattHrsTotal
        coinTotal
        rideDurTotal
        updatedAt
        rides {
          nextToken
        }
        questEfforts {
          nextToken
        }
      }
      questEfforts {
        items {
          id
          createdAt
          score
          metric
          starRating
          starGain
          completed
          isRankChecked
          owner
          questId
          rideId
          updatedAt
        }
        nextToken
      }
      questRanks {
        items {
          createdAt
          score
          starRating
          owner
          questId
          rideId
          effortId
          updatedAt
        }
        nextToken
      }
      world {
        id
        title
        createdAt
        updatedAt
        quests {
          nextToken
        }
      }
    }
  }
`;
export const deleteRide = /* GraphQL */ `
  mutation DeleteRide(
    $input: DeleteRideInput!
    $condition: ModelRideConditionInput
  ) {
    deleteRide(input: $input, condition: $condition) {
      id
      createdAt
      title
      duration
      kilometers
      wattHours
      coinGain
      starGain
      completed
      owner
      worldId
      updatedAt
      player {
        id
        purpose
        name
        starTotal
        effortTotal
        rideDurTotal
        wattHrsTotal
        coinTotal
        createdAt
        updatedAt
        restricted {
          id
          stravaAccessToken
          stravaRefreshToken
          stravaTokenExpiresAt
          stravaScope
          createdAt
          updatedAt
        }
      }
      activityPeriod {
        id
        createdAt
        owner
        startDate
        effortCount
        starCount
        wattHrs
        coinCount
        rideDuration
        effortTotal
        starTotal
        wattHrsTotal
        coinTotal
        rideDurTotal
        updatedAt
        rides {
          nextToken
        }
        questEfforts {
          nextToken
        }
      }
      questEfforts {
        items {
          id
          createdAt
          score
          metric
          starRating
          starGain
          completed
          isRankChecked
          owner
          questId
          rideId
          updatedAt
        }
        nextToken
      }
      questRanks {
        items {
          createdAt
          score
          starRating
          owner
          questId
          rideId
          effortId
          updatedAt
        }
        nextToken
      }
      world {
        id
        title
        createdAt
        updatedAt
        quests {
          nextToken
        }
      }
    }
  }
`;
export const createQuestEffort = /* GraphQL */ `
  mutation CreateQuestEffort(
    $input: CreateQuestEffortInput!
    $condition: ModelQuestEffortConditionInput
  ) {
    createQuestEffort(input: $input, condition: $condition) {
      id
      createdAt
      score
      metric
      starRating
      starGain
      completed
      isRankChecked
      owner
      questId
      rideId
      updatedAt
      player {
        id
        purpose
        name
        starTotal
        effortTotal
        rideDurTotal
        wattHrsTotal
        coinTotal
        createdAt
        updatedAt
        restricted {
          id
          stravaAccessToken
          stravaRefreshToken
          stravaTokenExpiresAt
          stravaScope
          createdAt
          updatedAt
        }
      }
      activityPeriod {
        id
        createdAt
        owner
        startDate
        effortCount
        starCount
        wattHrs
        coinCount
        rideDuration
        effortTotal
        starTotal
        wattHrsTotal
        coinTotal
        rideDurTotal
        updatedAt
        rides {
          nextToken
        }
        questEfforts {
          nextToken
        }
      }
      ride {
        id
        createdAt
        title
        duration
        kilometers
        wattHours
        coinGain
        starGain
        completed
        owner
        worldId
        updatedAt
        player {
          id
          purpose
          name
          starTotal
          effortTotal
          rideDurTotal
          wattHrsTotal
          coinTotal
          createdAt
          updatedAt
        }
        activityPeriod {
          id
          createdAt
          owner
          startDate
          effortCount
          starCount
          wattHrs
          coinCount
          rideDuration
          effortTotal
          starTotal
          wattHrsTotal
          coinTotal
          rideDurTotal
          updatedAt
        }
        questEfforts {
          nextToken
        }
        questRanks {
          nextToken
        }
        world {
          id
          title
          createdAt
          updatedAt
        }
      }
      quest {
        id
        title
        worldId
        type
        kilometers
        checkpointCount
        starsToUnlock
        createdAt
        updatedAt
      }
    }
  }
`;
export const updateQuestEffort = /* GraphQL */ `
  mutation UpdateQuestEffort(
    $input: UpdateQuestEffortInput!
    $condition: ModelQuestEffortConditionInput
  ) {
    updateQuestEffort(input: $input, condition: $condition) {
      id
      createdAt
      score
      metric
      starRating
      starGain
      completed
      isRankChecked
      owner
      questId
      rideId
      updatedAt
      player {
        id
        purpose
        name
        starTotal
        effortTotal
        rideDurTotal
        wattHrsTotal
        coinTotal
        createdAt
        updatedAt
        restricted {
          id
          stravaAccessToken
          stravaRefreshToken
          stravaTokenExpiresAt
          stravaScope
          createdAt
          updatedAt
        }
      }
      activityPeriod {
        id
        createdAt
        owner
        startDate
        effortCount
        starCount
        wattHrs
        coinCount
        rideDuration
        effortTotal
        starTotal
        wattHrsTotal
        coinTotal
        rideDurTotal
        updatedAt
        rides {
          nextToken
        }
        questEfforts {
          nextToken
        }
      }
      ride {
        id
        createdAt
        title
        duration
        kilometers
        wattHours
        coinGain
        starGain
        completed
        owner
        worldId
        updatedAt
        player {
          id
          purpose
          name
          starTotal
          effortTotal
          rideDurTotal
          wattHrsTotal
          coinTotal
          createdAt
          updatedAt
        }
        activityPeriod {
          id
          createdAt
          owner
          startDate
          effortCount
          starCount
          wattHrs
          coinCount
          rideDuration
          effortTotal
          starTotal
          wattHrsTotal
          coinTotal
          rideDurTotal
          updatedAt
        }
        questEfforts {
          nextToken
        }
        questRanks {
          nextToken
        }
        world {
          id
          title
          createdAt
          updatedAt
        }
      }
      quest {
        id
        title
        worldId
        type
        kilometers
        checkpointCount
        starsToUnlock
        createdAt
        updatedAt
      }
    }
  }
`;
export const deleteQuestEffort = /* GraphQL */ `
  mutation DeleteQuestEffort(
    $input: DeleteQuestEffortInput!
    $condition: ModelQuestEffortConditionInput
  ) {
    deleteQuestEffort(input: $input, condition: $condition) {
      id
      createdAt
      score
      metric
      starRating
      starGain
      completed
      isRankChecked
      owner
      questId
      rideId
      updatedAt
      player {
        id
        purpose
        name
        starTotal
        effortTotal
        rideDurTotal
        wattHrsTotal
        coinTotal
        createdAt
        updatedAt
        restricted {
          id
          stravaAccessToken
          stravaRefreshToken
          stravaTokenExpiresAt
          stravaScope
          createdAt
          updatedAt
        }
      }
      activityPeriod {
        id
        createdAt
        owner
        startDate
        effortCount
        starCount
        wattHrs
        coinCount
        rideDuration
        effortTotal
        starTotal
        wattHrsTotal
        coinTotal
        rideDurTotal
        updatedAt
        rides {
          nextToken
        }
        questEfforts {
          nextToken
        }
      }
      ride {
        id
        createdAt
        title
        duration
        kilometers
        wattHours
        coinGain
        starGain
        completed
        owner
        worldId
        updatedAt
        player {
          id
          purpose
          name
          starTotal
          effortTotal
          rideDurTotal
          wattHrsTotal
          coinTotal
          createdAt
          updatedAt
        }
        activityPeriod {
          id
          createdAt
          owner
          startDate
          effortCount
          starCount
          wattHrs
          coinCount
          rideDuration
          effortTotal
          starTotal
          wattHrsTotal
          coinTotal
          rideDurTotal
          updatedAt
        }
        questEfforts {
          nextToken
        }
        questRanks {
          nextToken
        }
        world {
          id
          title
          createdAt
          updatedAt
        }
      }
      quest {
        id
        title
        worldId
        type
        kilometers
        checkpointCount
        starsToUnlock
        createdAt
        updatedAt
      }
    }
  }
`;
export const createQuestRank = /* GraphQL */ `
  mutation CreateQuestRank(
    $input: CreateQuestRankInput!
    $condition: ModelQuestRankConditionInput
  ) {
    createQuestRank(input: $input, condition: $condition) {
      createdAt
      score
      starRating
      owner
      questId
      rideId
      effortId
      updatedAt
      player {
        id
        purpose
        name
        starTotal
        effortTotal
        rideDurTotal
        wattHrsTotal
        coinTotal
        createdAt
        updatedAt
        restricted {
          id
          stravaAccessToken
          stravaRefreshToken
          stravaTokenExpiresAt
          stravaScope
          createdAt
          updatedAt
        }
      }
      ride {
        id
        createdAt
        title
        duration
        kilometers
        wattHours
        coinGain
        starGain
        completed
        owner
        worldId
        updatedAt
        player {
          id
          purpose
          name
          starTotal
          effortTotal
          rideDurTotal
          wattHrsTotal
          coinTotal
          createdAt
          updatedAt
        }
        activityPeriod {
          id
          createdAt
          owner
          startDate
          effortCount
          starCount
          wattHrs
          coinCount
          rideDuration
          effortTotal
          starTotal
          wattHrsTotal
          coinTotal
          rideDurTotal
          updatedAt
        }
        questEfforts {
          nextToken
        }
        questRanks {
          nextToken
        }
        world {
          id
          title
          createdAt
          updatedAt
        }
      }
      effort {
        id
        createdAt
        score
        metric
        starRating
        starGain
        completed
        isRankChecked
        owner
        questId
        rideId
        updatedAt
        player {
          id
          purpose
          name
          starTotal
          effortTotal
          rideDurTotal
          wattHrsTotal
          coinTotal
          createdAt
          updatedAt
        }
        activityPeriod {
          id
          createdAt
          owner
          startDate
          effortCount
          starCount
          wattHrs
          coinCount
          rideDuration
          effortTotal
          starTotal
          wattHrsTotal
          coinTotal
          rideDurTotal
          updatedAt
        }
        ride {
          id
          createdAt
          title
          duration
          kilometers
          wattHours
          coinGain
          starGain
          completed
          owner
          worldId
          updatedAt
        }
        quest {
          id
          title
          worldId
          type
          kilometers
          checkpointCount
          starsToUnlock
          createdAt
          updatedAt
        }
      }
      quest {
        id
        title
        worldId
        type
        kilometers
        checkpointCount
        starsToUnlock
        createdAt
        updatedAt
      }
    }
  }
`;
export const updateQuestRank = /* GraphQL */ `
  mutation UpdateQuestRank(
    $input: UpdateQuestRankInput!
    $condition: ModelQuestRankConditionInput
  ) {
    updateQuestRank(input: $input, condition: $condition) {
      createdAt
      score
      starRating
      owner
      questId
      rideId
      effortId
      updatedAt
      player {
        id
        purpose
        name
        starTotal
        effortTotal
        rideDurTotal
        wattHrsTotal
        coinTotal
        createdAt
        updatedAt
        restricted {
          id
          stravaAccessToken
          stravaRefreshToken
          stravaTokenExpiresAt
          stravaScope
          createdAt
          updatedAt
        }
      }
      ride {
        id
        createdAt
        title
        duration
        kilometers
        wattHours
        coinGain
        starGain
        completed
        owner
        worldId
        updatedAt
        player {
          id
          purpose
          name
          starTotal
          effortTotal
          rideDurTotal
          wattHrsTotal
          coinTotal
          createdAt
          updatedAt
        }
        activityPeriod {
          id
          createdAt
          owner
          startDate
          effortCount
          starCount
          wattHrs
          coinCount
          rideDuration
          effortTotal
          starTotal
          wattHrsTotal
          coinTotal
          rideDurTotal
          updatedAt
        }
        questEfforts {
          nextToken
        }
        questRanks {
          nextToken
        }
        world {
          id
          title
          createdAt
          updatedAt
        }
      }
      effort {
        id
        createdAt
        score
        metric
        starRating
        starGain
        completed
        isRankChecked
        owner
        questId
        rideId
        updatedAt
        player {
          id
          purpose
          name
          starTotal
          effortTotal
          rideDurTotal
          wattHrsTotal
          coinTotal
          createdAt
          updatedAt
        }
        activityPeriod {
          id
          createdAt
          owner
          startDate
          effortCount
          starCount
          wattHrs
          coinCount
          rideDuration
          effortTotal
          starTotal
          wattHrsTotal
          coinTotal
          rideDurTotal
          updatedAt
        }
        ride {
          id
          createdAt
          title
          duration
          kilometers
          wattHours
          coinGain
          starGain
          completed
          owner
          worldId
          updatedAt
        }
        quest {
          id
          title
          worldId
          type
          kilometers
          checkpointCount
          starsToUnlock
          createdAt
          updatedAt
        }
      }
      quest {
        id
        title
        worldId
        type
        kilometers
        checkpointCount
        starsToUnlock
        createdAt
        updatedAt
      }
    }
  }
`;
export const deleteQuestRank = /* GraphQL */ `
  mutation DeleteQuestRank(
    $input: DeleteQuestRankInput!
    $condition: ModelQuestRankConditionInput
  ) {
    deleteQuestRank(input: $input, condition: $condition) {
      createdAt
      score
      starRating
      owner
      questId
      rideId
      effortId
      updatedAt
      player {
        id
        purpose
        name
        starTotal
        effortTotal
        rideDurTotal
        wattHrsTotal
        coinTotal
        createdAt
        updatedAt
        restricted {
          id
          stravaAccessToken
          stravaRefreshToken
          stravaTokenExpiresAt
          stravaScope
          createdAt
          updatedAt
        }
      }
      ride {
        id
        createdAt
        title
        duration
        kilometers
        wattHours
        coinGain
        starGain
        completed
        owner
        worldId
        updatedAt
        player {
          id
          purpose
          name
          starTotal
          effortTotal
          rideDurTotal
          wattHrsTotal
          coinTotal
          createdAt
          updatedAt
        }
        activityPeriod {
          id
          createdAt
          owner
          startDate
          effortCount
          starCount
          wattHrs
          coinCount
          rideDuration
          effortTotal
          starTotal
          wattHrsTotal
          coinTotal
          rideDurTotal
          updatedAt
        }
        questEfforts {
          nextToken
        }
        questRanks {
          nextToken
        }
        world {
          id
          title
          createdAt
          updatedAt
        }
      }
      effort {
        id
        createdAt
        score
        metric
        starRating
        starGain
        completed
        isRankChecked
        owner
        questId
        rideId
        updatedAt
        player {
          id
          purpose
          name
          starTotal
          effortTotal
          rideDurTotal
          wattHrsTotal
          coinTotal
          createdAt
          updatedAt
        }
        activityPeriod {
          id
          createdAt
          owner
          startDate
          effortCount
          starCount
          wattHrs
          coinCount
          rideDuration
          effortTotal
          starTotal
          wattHrsTotal
          coinTotal
          rideDurTotal
          updatedAt
        }
        ride {
          id
          createdAt
          title
          duration
          kilometers
          wattHours
          coinGain
          starGain
          completed
          owner
          worldId
          updatedAt
        }
        quest {
          id
          title
          worldId
          type
          kilometers
          checkpointCount
          starsToUnlock
          createdAt
          updatedAt
        }
      }
      quest {
        id
        title
        worldId
        type
        kilometers
        checkpointCount
        starsToUnlock
        createdAt
        updatedAt
      }
    }
  }
`;
